export default {output:'ВЫВОД'};